"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _scene7UrlParser = require("../../utils/scene7/scene7UrlParser");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["src", "smallSrc", "alt", "sizes", "widths", "maxWidth", "loading"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** The source of the image in Scene7 */
  src: _propTypes["default"].string.isRequired,
  /** The source of a different version of the image, perhaps with a different art direction intended for smaller screens */
  smallSrc: _propTypes["default"].string,
  /** The alt text you want displayed on the img */
  alt: _propTypes["default"].string,
  /** Defines the size the image should be according to a set of media conditions */
  sizes: _propTypes["default"].string,
  /** An array of widths the image should be loaded at */
  widths: _propTypes["default"].arrayOf(_propTypes["default"].number),
  /** Used with the default array of widths to specify which one the image stops rendering correctly at */
  maxWidth: _propTypes["default"].number,
  /** Specify the loading attribute for the img tag */
  loading: _propTypes["default"].string
};
var defaultProps = {
  smallSrc: undefined,
  alt: '',
  sizes: '100vw',
  widths: [576, 768, 1024, 1200, 1536, 2048, 2400],
  maxWidth: 2400,
  loading: 'lazy'
};
var Scene7 = function Scene7(_ref) {
  var src = _ref.src,
    smallSrc = _ref.smallSrc,
    alt = _ref.alt,
    sizes = _ref.sizes,
    widths = _ref.widths,
    maxWidth = _ref.maxWidth,
    loading = _ref.loading,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var srcSet = widths.map(function (width) {
    if (width <= maxWidth) return "".concat((0, _scene7UrlParser.setScene7UrlQueryParams)(src, {
      wid: width
    }), " ").concat(width, "w");
    return null;
  });
  var img = /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread({
    src: src,
    srcSet: srcSet.join(', '),
    sizes: sizes,
    alt: alt,
    loading: loading
  }, otherProps));
  if (!smallSrc) return img;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("picture", {
    children: [smallSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      media: "(max-width: 767px)",
      srcSet: "".concat((0, _scene7UrlParser.setScene7UrlQueryParams)(smallSrc, {
        scale: '0.5'
      }), " 1x, ").concat(smallSrc, "? 2x"),
      sizes: "100vw"
    }), img]
  });
};
Scene7.propTypes = propTypes;
Scene7.defaultProps = defaultProps;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Scene7);